// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic

// styles
import './styles/graphic.scss';

/* develblock:start */

import * as d3 from 'd3';
import { format } from 'd3-format';
import meta from './data/meta.json';
import { stylePremium } from './utils/helpers';
import { bandAxis, linearAxis } from '../../../factory/axes';

import './styles/graphic.scss';

// formatD3Time();
d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

const fmtComma = format(',');
const fmtSI = format('.2f');
const fmtThou = format('~s');
const fmtPercent = d3.format('.1f'); // rounds to one decimal
const fmtAxis = d3.format('.0%');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


let minValue;
let maxValue;


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let data;

// Define these helpers in the global scope
const parseDate = d3.timeParse('%Y-%m-%d');
const formatQuarter = (date) => {
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  return `Q${quarter} ${date.getFullYear()}`;
};

d3.json('https://ix.cnn.io/data/gdp-change/real_gdp_quarterly_change_es.json').then((jsondata) => {
  const sevenYearsAgo = new Date();
  sevenYearsAgo.setFullYear(sevenYearsAgo.getFullYear() - 7);

  // Parser for dates
  const parseDate = d3.timeParse('%Y-%m-%d');
  // Formatter to convert a date into a "Q# YYYY" string
  const formatQuarter = (date) => {
    const quarter = Math.floor(date.getMonth() / 3) + 1;
    return `Q${quarter} ${date.getFullYear()}`;
  };

  data = jsondata.data
    .map((d) => {
      const parsedDate = parseDate(d.date);
      return {
        date: parsedDate,
        amt: d.value,
        label: formatQuarter(parsedDate), // Use quarter label instead of month abbreviation
      };
    })
    .filter(d => d.date >= sevenYearsAgo)
    .sort((a, b) => a.date - b.date);
  // Limit to last 16 quarters
  data = data.slice(-17);

  // Calculate min and max for chart scale
  minValue = Math.min(0, d3.min(data, d => d.amt));
  maxValue = d3.max(data, d => d.amt);

  // Update headline, dek, and timestamp from JSON keys
  d3.select('h1.headline').html(`Seguimiento del PIB: ${jsondata.headline}`);
  d3.select('h2.dek').html(`${jsondata.msg}`);
  d3.select('p#timestamp').html(`Notas: Las cifras representan tasas anuales ajustadas estacionalmente. Datos actualizados hasta el ${jsondata.quarter_name}, al ${jsondata.last_updated_str}.`);

  draw();
  window.onresize = draw;
});


function draw() {
  const container = d3.select('#graphic');
  container.html('');

  // Overall dimensions
  const width = container.node().clientWidth;
  const height = 400;
  const margins = {
    top: 40,
    right: 30,
    bottom: 25,
    left: 40,
  };
  const chartWidth = width - margins.left - margins.right;
  const chartHeight = height - margins.top - margins.bottom;

  // -- Bars --
  const barWidth = (chartWidth / data.length) * 0.7;

  // Adjust x scale so bars align with y-axis
  const x = d3.scaleTime()
    .domain(d3.extent(data, d => d.date))
    .range([barWidth / 2, chartWidth - barWidth / 2]);

  // 2) Linear scale for Y
  const y = d3.scaleLinear()
    .domain([Math.min(0, minValue), maxValue])
    .range([chartHeight, 0])
    .nice();

  const xAxis = d3.axisBottom(x)
    .ticks(6)
    .tickFormat(formatQuarter);

  const yAxis = d3.axisLeft(y)
    .ticks(5)
    .tickSize(-chartWidth)
    .tickFormat(d => `${d}%`)
    .tickPadding(15);

  // Create the SVG
  const svg = container.append('svg')
    .attr('width', width)
    .attr('height', height);

  // Main chart group
  const g = svg.append('g')
    .attr('transform', `translate(${margins.left},${margins.top})`);

  // -- COVID Highlight: Q1-Q3 2020 --
  const covidStart = new Date('2019-12-01');
  const covidEnd = new Date('2020-08-01');

  // Compute highlight positions with the same x scale
  const highlightStart = x(covidStart);
  const highlightEnd = x(covidEnd);

  // g.append('rect')
  //   .attr('class', 'covid-box')
  //   .attr('x', highlightStart)
  //   .attr('y', 0)
  //   .attr('width', highlightEnd - highlightStart)
  //   .attr('height', chartHeight)
  //   .attr('fill', '#ccc')
  //   .attr('opacity', 0.3);

  // Label above the highlight area
  const covidMid = (highlightStart + highlightEnd) / 2;
  // g.append('text')
  //   .attr('class', 'covid-label')
  //   .attr('x', covidMid)
  //   .attr('y', -10)
  //   .attr('text-anchor', 'middle')
  //   .attr('fill', '#666')
  //   .style('font-size', '12px')
  //   .style('font-style', 'italic')
  //   .text('Covid-19 slowdown, recovery');

  // -- X Axis --
  g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(0,${chartHeight})`)
    .call(xAxis);

  // -- Y Axis (with grid lines) --
  g.append('g')
    .attr('class', 'y grid')
    .call(yAxis);

  const bars = g.append('g').attr('class', 'data');
  bars.selectAll('.bar')
    .data(data)
    .enter().append('rect')
    .attr('class', (d, i) => {
      const classes = ['bar'];
      if (d.amt < 0) classes.push('loss');
      if (i === data.length - 1) classes.push('highlight');
      return classes.join(' ');
    })
    // Center each bar on its date
    .attr('x', d => x(d.date) - barWidth / 2)
    .attr('y', d => y(Math.max(0, d.amt)))
    .attr('width', barWidth)
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  // -- Last-bar label (e.g. "2.3%") --
  const lastData = data[data.length - 1];
  if (lastData) {
    // Calculate label position based on value
    const labelOffset = lastData.amt >= 0 ? -32 : 32; // Increased from ±25 to ±32
    const barEndOffset = lastData.amt >= 0 ? -2 : 2; // 4px away from bar end

    g.append('text')
      .attr('class', 'label last-bar-label')
      .attr('x', x(lastData.date))
      .attr('y', y(Math.max(0, lastData.amt)) + labelOffset)
      .attr('text-anchor', 'middle')
      .style('font-weight', 'bold')
      .text(`${d3.format('.1f')(lastData.amt).replace('.', ',')} %`);

    // Add connecting line from just outside the bar to just under/over the label
    g.append('line')
      .attr('class', 'connector-line')
      .attr('x1', x(lastData.date))
      .attr('x2', x(lastData.date))
      .attr('y1', y(lastData.amt) + barEndOffset)
      .attr('y2', y(Math.max(0, lastData.amt)) + (lastData.amt >= 0 ? -18 : 18)) // just under/over the label
      .style('stroke', '#666')
      .style('stroke-width', 1);
  }

  // -- Zero line if needed --
  if (y.domain()[0] < 0) {
    g.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', chartWidth)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }

  // Resize handling
  window.pymChild.sendHeight();
  d3.select('#root').attr('class', 'ready');
}
